import { useEffect, useState } from "react";
import { listNewArrivals, type NewArrival } from "@/features/new-arrivals/api";

/**
 * The single most-recent client still mid-onboarding, for the dashboard's
 * "Client onboarding" preview card. The `/clients/new-arrivals/` endpoint
 * already excludes fully-onboarded clients and orders by `-created_at`, so the
 * first row is the newest arrival in progress. Returns `null` when the queue is
 * empty (all caught up) or the read fails — the card renders a sensible
 * fallback either way, matching `useDashboardStats`'s per-source tolerance.
 */
export function useNewestArrival(): { arrival: NewArrival | null; loading: boolean } {
  const [arrival, setArrival] = useState<NewArrival | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    listNewArrivals({ pageSize: 1 })
      .then((res) => {
        if (active) setArrival(res.arrivals[0] ?? null);
      })
      .catch(() => active && setArrival(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { arrival, loading };
}
